import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip,
    Button
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";
import InvoiceCommentList from "./InvoiceCommentList";

const ViewInvoice = (props) => {
    const { open, handleClose, rowData } = props;

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    const formatINR = (value) => {
        if (!value && value !== 0) return "N/A";
        return Number(value).toLocaleString("en-IN");
    };

    return (
        <>
            <Dialog
                open={open}
                fullScreen
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        overflowX: "hidden"
                    },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View Invoice Details
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>

                        <Grid size={{ md: 6, xs: 12 }}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: "3px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fff",
                                    p: 2,
                                }}
                            >
                                {/* Header */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                        Invoice Information
                                    </Typography>
                                </Box>

                                <Divider sx={{ mb: 2 }} />

                                <CardContent sx={{ pt: 0 }}>
                                    <Grid container spacing={2}>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Vendor Name:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.vendorName ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>WO/Contract No:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.woContractNo ? rowData?.woContractNo : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Invoice Particulars:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.invoiceParticulars ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Type:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.type ? rowData?.type : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Invoice No.:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.invoiceNo ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Invoice Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.invoiceDate ? moment.utc(rowData?.invoiceDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Total Invoice Amount (Inc GST):</Typography>
                                            <Typography sx={valueStyle}>{formatINR(rowData?.totalInvoiceAmountIncGst)}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Received From Vendor:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.receivedFromVendor ? moment.utc(rowData?.receivedFromVendor).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Invoice Received For PMO Review:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.invoiceReceivedForPmoReview ? moment.utc(rowData?.invoiceReceivedForPmoReview).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>PMO Review:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.pmoReview ? moment.utc(rowData?.pmoReview).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>PMO Review After Comments Incorporated:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.pmoReviewAfterCommentsIncorporated ? moment.utc(rowData?.pmoReviewAfterCommentsIncorporated).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Sent to Approver 1:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.sentToApprover1 ? moment.utc(rowData?.sentToApprover1).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 1:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.approver1 ? rowData?.approver1 : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 1 Approval Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.approver1ApprovalDate ? moment.utc(rowData?.approver1ApprovalDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Sent to Approver 2:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.sentToApprover2 ? moment.utc(rowData?.sentToApprover2).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 2:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.approver2 ? rowData?.approver2 : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 2 Approval Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.approver2ApprovalDate ? moment.utc(rowData?.approver2ApprovalDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Sent to Approver 3:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.sentToApprover3 ? moment.utc(rowData?.sentToApprover3).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 3:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.approver3 ? rowData?.approver3 : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 3 Approval Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.approver3ApprovalDate ? moment.utc(rowData?.approver3ApprovalDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Sent to Approver 4:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.sentToApprover4 ? moment.utc(rowData?.sentToApprover4).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 4:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.approver4 ? rowData?.approver4 : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 4 Approval Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.approver4ApprovalDate ? moment.utc(rowData?.approver4ApprovalDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Sent to Approver 5:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.sentToApprover5 ? moment.utc(rowData?.sentToApprover5).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 5:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.approver5 ? rowData?.approver5 : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Approver 5 Approval Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.approver5ApprovalDate ? moment.utc(rowData?.approver5ApprovalDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Finance Submission Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.financeSubmissionDate ? moment.utc(rowData?.financeSubmissionDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Payment Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.paymentDate ? moment.utc(rowData?.paymentDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Paid Amount:</Typography>
                                            <Typography sx={valueStyle}>{formatINR(rowData?.paidAmount)}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Status:</Typography>
                                            <StatusBadge status={rowData?.status} />
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Hold Reason / Observations:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.holdReasonObservations ? rowData?.holdReasonObservations : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>UTR No.:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.utrNo ? rowData?.utrNo : "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Invoice Ageing For Approvals:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.invoiceAgeingForApprovals ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Invoice Ageing For Payments:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.invoiceAgeingForPayments ?? "N/A"}</Typography>
                                        </Grid>

                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid
                            size={{ md: 6, xs: 12 }}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                height: '90vh', // adjustable
                                border: "1px solid #e0e0e0",
                                borderRadius: 2,
                                overflow: "auto",
                            }}
                        >
                            <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
                                {/* Comment list */}
                                <InvoiceCommentList data={rowData} />
                            </Box>
                        </Grid>

                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ViewInvoice;